import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\FetchContactDossierByIdController::__invoke
* @see app/Http/Controllers/Dossier/FetchContactDossierByIdController.php
* @route '/api/dossier-contacts/{dossier}'
*/
const FetchContactDossierByIdController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchContactDossierByIdController.url(args, options),
    method: 'get',
})

FetchContactDossierByIdController.definition = {
    methods: ["get","head"],
    url: '/api/dossier-contacts/{dossier}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Dossier\FetchContactDossierByIdController::__invoke
* @see app/Http/Controllers/Dossier/FetchContactDossierByIdController.php
* @route '/api/dossier-contacts/{dossier}'
*/
FetchContactDossierByIdController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return FetchContactDossierByIdController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\FetchContactDossierByIdController::__invoke
* @see app/Http/Controllers/Dossier/FetchContactDossierByIdController.php
* @route '/api/dossier-contacts/{dossier}'
*/
FetchContactDossierByIdController.get = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchContactDossierByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Dossier\FetchContactDossierByIdController::__invoke
* @see app/Http/Controllers/Dossier/FetchContactDossierByIdController.php
* @route '/api/dossier-contacts/{dossier}'
*/
FetchContactDossierByIdController.head = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: FetchContactDossierByIdController.url(args, options),
    method: 'head',
})

export default FetchContactDossierByIdController